var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___bjVaWT",
  "r9": "Checkbox.module__disabled___bjVaWT",
  "iD": "Checkbox.module__menuDisabled___bjVaWT",
  "kv": "Checkbox.module__checkbox___bjVaWT",
  "aP": "Checkbox.module__box___bjVaWT",
  "LI": "Checkbox.module__round___bjVaWT",
  "KD": "Checkbox.module__checked___bjVaWT",
  "oE": "Checkbox.module__checkIcon___bjVaWT",
  "Pf": "Checkbox.module__label___bjVaWT",
  "hJ": "Checkbox.module__labelInteractive___bjVaWT",
  "QK": "Checkbox.module__labelText___bjVaWT",
  "nV": "Checkbox.module__labelFocusRing___bjVaWT",
  "P8": "Checkbox.module__menuChecked___bjVaWT",
  "fb": "Checkbox.module__checkboxIndicator___bjVaWT",
};

module.exports = exports;
